import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TextService {
    constructor() { }
    static countTextContent(htmlString: string) {
        const textOnly = htmlString?.replace(/<[^>]*>/g, '');
        const trimmedText = textOnly.trim();
        const wordCount = trimmedText.length > 0 ? trimmedText.split(/\s+/).length : 0;
        return wordCount;
    }


    generateRandomString(length = 5) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters[randomIndex];
        }
        return result;
    }

    generateGUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0;
            const v = (c === 'x') ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }


}